import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, Form } from 'react-final-form';
import { Button, translate, Checkbox } from '@haldor/ui';
import { getNotificationSettings } from 'actions/notifications';

var NotificationOptionForm = /*#__PURE__*/function (_Component) {
  _inherits(NotificationOptionForm, _Component);

  var _super = _createSuper(NotificationOptionForm);

  function NotificationOptionForm() {
    var _this;

    _classCallCheck(this, NotificationOptionForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props$notificat;

      if (_this.props.notificationSettings == null || ((_this$props$notificat = _this.props.notificationSettings) === null || _this$props$notificat === void 0 ? void 0 : _this$props$notificat.length) <= 0) {
        _this.props.getNotificationSettings();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      return new Promise(function (resolve) {
        var _this$props$notificat2;

        var data = [];
        (_this$props$notificat2 = _this.props.notificationSettings) === null || _this$props$notificat2 === void 0 ? void 0 : _this$props$notificat2.forEach(function (setting) {
          var notificationSpaces = setting.notificationSpace.split(',');
          notificationSpaces === null || notificationSpaces === void 0 ? void 0 : notificationSpaces.forEach(function (space) {
            var _values$settings;

            var userSetting = (_values$settings = values.settings) === null || _values$settings === void 0 ? void 0 : _values$settings.find(function (s) {
              return s.notificationSettingId == setting.id && s.notificationSpace == space.trim();
            });

            if (userSetting != null) {
              data.push(userSetting);
            } else {
              var object = {
                notificationSettingId: setting.id,
                notificationSpace: space.trim(),
                enabled: true
              };
              data.push(object);
            }
          });
        });

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(data).then(function () {
            resolve(1);
          });
        } else {
          resolve(1);
        }

        if (_this.props.onAbort != null) {
          _this.props.onAbort();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderField", function (field) {
      var value = false;

      if (field.input.value != '') {
        value = field.input.value.find(function (s) {
          return s.notificationSettingId == field.setting.id && s.notificationSpace.includes(field.space) && s.enabled == true;
        }) != null;
      }

      return /*#__PURE__*/React.createElement(Checkbox, {
        value: value,
        onChange: function onChange(checked) {
          var _values;

          var values = [];

          if (field.input.value != '') {
            values = field.input.value;
          }

          var userSetting = (_values = values) === null || _values === void 0 ? void 0 : _values.find(function (s) {
            return s.notificationSettingId == field.setting.id && s.notificationSpace == field.space;
          });

          if (userSetting) {
            userSetting.enabled = checked;
          } else {
            var object = {
              notificationSettingId: field.setting.id,
              notificationSpace: field.space,
              enabled: checked
            };
            values.push(object);
          }

          field.input.onChange(values);
        }
      });
    });

    return _this;
  }

  _createClass(NotificationOptionForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var notice = this.props.translate('notice-notificationsettings');

      if (notice == 'notice-notificationsettings') {
        notice = '';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 1.75rem'
        }
      }, /*#__PURE__*/React.createElement(Form, {
        initialValues: {
          settings: this.props.values
        },
        onSubmit: this.onSubmit,
        render: function render(_ref) {
          var _this2$props$notifica;

          var submitting = _ref.submitting,
              handleSubmit = _ref.handleSubmit;
          return /*#__PURE__*/React.createElement("form", {
            className: "form form-component",
            onSubmit: handleSubmit
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement("table", {
            className: "modal-content"
          }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, _this2.props.translate('My notifications')), /*#__PURE__*/React.createElement("th", null, _this2.props.translate('Events')), /*#__PURE__*/React.createElement("th", {
            style: {
              paddingLeft: '1rem'
            }
          }, _this2.props.translate('Teams')))), /*#__PURE__*/React.createElement("tbody", null, (_this2$props$notifica = _this2.props.notificationSettings) === null || _this2$props$notifica === void 0 ? void 0 : _this2$props$notifica.map(function (setting) {
            return /*#__PURE__*/React.createElement("tr", {
              key: setting.id
            }, /*#__PURE__*/React.createElement("td", {
              style: {
                paddingRight: '2rem'
              }
            }, _this2.props.translate(setting.text)), /*#__PURE__*/React.createElement("td", null, setting.notificationSpace.includes('Events') ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
              component: _this2.renderField,
              name: 'settings',
              setting: setting,
              space: "Events"
            })) : null), /*#__PURE__*/React.createElement("td", {
              style: {
                paddingLeft: '1rem'
              }
            }, setting.notificationSpace.includes('Teams') ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
              component: _this2.renderField,
              name: 'settings',
              setting: setting,
              space: "Teams"
            })) : null));
          }))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '3rem'
            },
            className: "df aic jcb"
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: submitting,
            id: "save-input"
          }, _this2.props.translate('save')), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(event) {
              event.preventDefault();

              _this2.props.onAbort(false);
            },
            type: "secondary"
          }, _this2.props.translate('Cancel')))));
        }
      })));
    }
  }]);

  return NotificationOptionForm;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    notificationSettings: state.Notifications.notificationSettings
  };
};

export default withRouter(connect(mapStateToProps, {
  getNotificationSettings: getNotificationSettings
})(NotificationOptionForm));